"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),t=require("react/jsx-runtime"),a=require("styled-components"),i=require("@vds/tables"),r=require("@vds-tokens/core"),o=require("@vds/typography"),d=require("@plans/utilities"),s=require("../tile/index.js");function n(e){return e&&e.__esModule?e:{default:e}}var l=n(a);const c=l.default(s.default).withConfig({displayName:"TileContainer",componentId:"VDS__sc-zuuntj-0"})`
  [class*='OuterTileContainer'] {
    ${({tableCellborderRadius:e})=>`border-radius: ${e} !important`};
  }
`,u=l.default(i.Table).withConfig({displayName:"Table",componentId:"VDS__sc-zuuntj-1"})`
  /* border-collapse: separate; */
  margin: 0px;
  padding-top: 0px;
  table-layout: fixed;

  thead {
    tr {
      
      border-bottom: 1px solid ${({surface:e})=>r.ColorTokens.elements.lowcontrast[`on${e}`].value} !important;
    }
  }

    tr td:first-child, tr th:first-child {
      padding-left: ${({sidePadding:e})=>e};
    }
    tr td:last-child , tr th:last-child {
      padding-right: ${({sidePadding:e})=>e};
    }

    tr:last-child td:first-child, tr:last-child th:first-child {
      border-bottom-left-radius: ${({tableCellborderRadius:e})=>`${e} !important;`};
    }
    tr:last-child td:last-child {
      border-bottom-right-radius: ${({tableCellborderRadius:e})=>`${e} !important;`};
    }
  }
`,p=l.default(i.TableHeader).withConfig({displayName:"ModifiedTableHeader",componentId:"VDS__sc-zuuntj-2"})`
  font-family: ${o.Fonts.VerizonNHGeTX};
  font-size: ${r.TypographyTokens.fontsize.body[12].value};
  font-weight: ${r.TypographyTokens.fontweight.regular.value};
  line-height: ${r.TypographyTokens.lineheight.body[16].value};
  @media (min-width: ${d.breakpoints.tabletSmall.min}) {
    font-family: ${o.Fonts.VerizonNHGeDS};
    font-size: ${r.TypographyTokens.fontsize.body[16].value};
    letter-spacing: ${r.TypographyTokens.letterspacing.wide.value};
    line-height: ${r.TypographyTokens.lineheight.body[20].value};
  }
`,b=l.default(i.Cell).withConfig({displayName:"ModifiedTableCell",componentId:"VDS__sc-zuuntj-3"})`
  ${({columnSpacing:e})=>"compact"===e&&a.css`
      :not(:first-child) {
        padding-left: 0px !important;
      }
    `}
`,h=l.default(i.TableHeader).withConfig({displayName:"ModifiedCellTitle",componentId:"VDS__sc-zuuntj-4"})`
  ${({columnSpacing:e})=>"compact"===e&&a.css`
      :not(:first-child) {
        padding-left: 0px !important;
      }
    `}
`;exports.default=a=>{var{surface:o="light",head:d,body:s,sidePadding:n=r.LayoutTokens.space["6X"].value,borderRadius:l=r.LayoutTokens.space["6X"].value,columnSpacing:g="standard"}=a,m=e.__rest(a,["surface","head","body","sidePadding","borderRadius","columnSpacing"]);const f=(e,a)=>e.cells.map(((e,i)=>0===i&&e.renderAsHeader?t.jsx(p,Object.assign({},e,{scope:"row"}),`table-row-${i}`):t.jsx(b,Object.assign({columnSpacing:g},e),`table-row-${a}-${i}`)));return t.jsx(c,Object.assign({showBorder:!0,borderRadius:l,tableCellborderRadius:l,background:"transparent",padding:"0px",height:"auto",surface:o,role:"presentation"},{children:t.jsxs(u,Object.assign({bottomLine:"secondary",sidePadding:n,tableCellborderRadius:l,padding:"compact",striped:!0,surface:o},m,{children:[t.jsx(i.TableHead,Object.assign({},d,{bottomLine:"secondary"},{children:d.headers.map(((e,a)=>e.children?t.jsx(h,Object.assign({columnSpacing:g},e,{scope:"col"}),`table-header-${a}`):t.jsx(b,Object.assign({columnSpacing:g},e),`table-header-${a}`)))})),t.jsx(i.TableBody,Object.assign({},s,{children:s.rows.map(((e,a)=>t.jsx(i.TableRow,Object.assign({},e,{bottomLine:a===s.rows.length-1?"none":"secondary"},{children:f(e,a)}),`table-row-${a}`)))}))]}))}))};
